// Generated by `pnpm gen:svg` from src/assets/svg — do not edit.
import type { ComponentType, SVGProps } from "react";
import { SvgBow } from "./SvgBow";
import { SvgCoffee } from "./SvgCoffee";
import { SvgCrown } from "./SvgCrown";
import { SvgDuck } from "./SvgDuck";
import { SvgEgg } from "./SvgEgg";
import { SvgHeadphones } from "./SvgHeadphones";
import { SvgMatcha } from "./SvgMatcha";
import { SvgMustache } from "./SvgMustache";
import { SvgPajamas } from "./SvgPajamas";
import { SvgPopsicle } from "./SvgPopsicle";
import { SvgSunglasses } from "./SvgSunglasses";

export {
  SvgBow,
  SvgCoffee,
  SvgCrown,
  SvgDuck,
  SvgEgg,
  SvgHeadphones,
  SvgMatcha,
  SvgMustache,
  SvgPajamas,
  SvgPopsicle,
  SvgSunglasses,
};

export type MascotComponent = ComponentType<
  SVGProps<SVGSVGElement> & { title?: string; titleId?: string }
>;

export type MascotName =
  | "bow"
  | "coffee"
  | "crown"
  | "duck"
  | "egg"
  | "headphones"
  | "matcha"
  | "mustache"
  | "pajamas"
  | "popsicle"
  | "sunglasses";

export const MascotMap = {
  bow: SvgBow,
  coffee: SvgCoffee,
  crown: SvgCrown,
  duck: SvgDuck,
  egg: SvgEgg,
  headphones: SvgHeadphones,
  matcha: SvgMatcha,
  mustache: SvgMustache,
  pajamas: SvgPajamas,
  popsicle: SvgPopsicle,
  sunglasses: SvgSunglasses,
} satisfies Record<MascotName, MascotComponent>;
